var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepStyleBackGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.268,
    height: 114.189,
    viewBox: "0 0 40.268 114.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4699",
    "data-name": "Group 4699",
    transform: "translate(-831.773 -605.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6980",
    "data-name": "Path 6980",
    d: "M163.483,408.009l-.516,6.537,15.826-.172-.688-8.085Z",
    transform: "translate(685.458 240.562)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6981",
    "data-name": "Path 6981",
    d: "M233.208,920.313l-4.395-2.864s.324,11.362-.336,11.8a6.1,6.1,0,0,0-1.685,1.611,1.205,1.205,0,0,0,.13,1.615l6.776,5.331c.383.283.987-.15.93-.667-.085-.758-.794-1.618-1.473-3.334a11.717,11.717,0,0,0-1.017-2.023c-.3-.473,1.071-11.469,1.071-11.469",
    transform: "translate(628.374 -218.369)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6982",
    "data-name": "Path 6982",
    d: "M139.331,918.092l4.4-2.86s-.334,11.362.325,11.8a6.1,6.1,0,0,1,1.684,1.612,1.205,1.205,0,0,1-.131,1.615l-6.781,5.325c-.383.283-.987-.151-.929-.668.085-.758.795-1.618,1.476-3.333a11.7,11.7,0,0,1,1.019-2.022c.3-.473-1.06-11.47-1.06-11.47",
    transform: "translate(707.969 -216.378)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6983",
    "data-name": "Path 6983",
    d: "M128.079,472.966c-2.44-.042-3.778,19.7-3.923,24.747s.291,26.215,2.761,27.518,5.667-.977,5.667-.977l1.889-27.518s.581,26.215,1.453,27.192,4.359,4.071,5.958.651,3.342-23.772,3.633-28.983-.493-22.807-1.453-22.63c-12.109,2.228-14.53.025-15.984,0",
    transform: "translate(720.325 180.699)",
    fill: "#b1d34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6984",
    "data-name": "Path 6984",
    d: "M99.6,33.941l-1.9-.264a125.209,125.209,0,0,0-25.841-.9,2.132,2.132,0,0,1-2.242-2.519l.364-1.952a45.776,45.776,0,0,0,.389-14.353h0A2.132,2.132,0,0,1,72.8,11.565l.338.05a125.208,125.208,0,0,0,25.776,1.146l1.566-.092A2.133,2.133,0,0,1,102.7,15.21l-.246,1.249a45.778,45.778,0,0,0-.543,14.245l.1.874A2.132,2.132,0,0,1,99.6,33.941",
    transform: "translate(769.298 594.975)",
    fill: "#d7e9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6985",
    "data-name": "Path 6985",
    d: "M112.709,487.274c-.22.266-1.126-1.53-1.126-1.53s.823,3.522.885,4.17-1.521-.511-1.432-.438c-.294.355-1.108-.468-1.123-.63-.707.312-.8-.661-1.374-.688-.678-1.141-.484-3.444-.362-4.423h-.015a18.324,18.324,0,0,0-.076-4.5,34.075,34.075,0,0,1,3.637-.632l-.13,3.685a3.6,3.6,0,0,0,.464,1.859,6.186,6.186,0,0,1,.651,3.123",
    transform: "translate(734.759 175.633)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6986",
    "data-name": "Path 6986",
    d: "M334.734,477.312c.21.274,1.182-1.487,1.182-1.487s-.953,3.489-1.038,4.135,1.539-.454,1.447-.384c.28.366,1.124-.427,1.145-.588.695.338.822-.631,1.4-.637.72-1.115.611-3.424.525-4.406h.015a18.333,18.333,0,0,1,.242-4.491,34.045,34.045,0,0,0-3.611-.765l-.006,3.687a3.6,3.6,0,0,1-.533,1.84,6.186,6.186,0,0,0-.766,3.1",
    transform: "translate(531.277 184.539)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6987",
    "data-name": "Path 6987",
    d: "M103.953,156.021S95.044,157.968,93.785,160s-5.478,16.45-4.456,24.8a40.281,40.281,0,0,0,.665,4.1,1.827,1.827,0,0,0,1.572,1.4c1.4.161,3.6.26,3.866-.655.387-1.356.387-14.7.387-14.7s.388,9.707.775,11.14c.43,1.59,16.4,1.759,16.662-.311.291-2.3.484-10.85.484-10.85s0,13.1,1.066,13.776,4.359,1.239,5.037.561-.678-24.6-4.262-28.964c-1.882-2.289-10.76-4.959-11.628-4.272",
    transform: "translate(751.713 465.357)",
    fill: "#b1d34a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6988",
    "data-name": "Path 6988",
    d: "M28.489,13.044s6.782-3.516,2.422-9.7S20.828.976,16.171,3.626,7.593.411,4.218,2.79s-7.5,12.651-.012,14.318,9.038-3,12.3-2.561,4.665,2.971,7.392,1.5a32.154,32.154,0,0,0,4.6-3",
    transform: "translate(831.773 605.333)",
    fill: "#221e3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6989",
    "data-name": "Path 6989",
    d: "M212.135,130.091a10.32,10.32,0,0,1-.329,2.425,2.953,2.953,0,0,0,2.621,3.786,3.527,3.527,0,0,0,2.245-.617c1.969-1.387,1.112-4.992,1.112-4.992Z",
    transform: "translate(641.712 488.539)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6990",
    "data-name": "Path 6990",
    d: "M215.287,130.091a10.789,10.789,0,0,1-.086,1.188,7.044,7.044,0,0,0,4.814,2.461,8.99,8.99,0,0,0,.982-.011,7.923,7.923,0,0,0-.061-3.037Z",
    transform: "translate(638.56 488.539)",
    fill: "#ef8062"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6991",
    "data-name": "Path 6991",
    d: "M203.922,59.457a2.67,2.67,0,0,0,.335.819c.664,1.061,2.753,3.768,6.117,2.391,4.139-1.694,3.293-9.581.6-10.423-3.1-.969-8.523.81-7.052,7.213",
    transform: "translate(648.909 558.654)",
    fill: "#ff9976"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4401",
    "data-name": "Rectangle 4401",
    width: 40.268,
    height: 114.189,
    transform: "translate(831.773 605.338)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepStyleBackGreen);
export default __webpack_public_path__ + "static/media/sleepStyleBackGreen.eb95b71071e32f1f8a16067848a83bc3.svg";
export { ForwardRef as ReactComponent };